import type Tool from './Tool';
import { type ToolArgsWithController } from './Tool';
import { ReactEditor } from 'slate-react';
import { type SyntheticEvent } from 'react';

// Fire the action of a tool and set focus correctly. This
// function is the only way that tool actions should be fired.
function fireToolAction(
  tool: typeof Tool,
  event: Event | SyntheticEvent,
  args: ToolArgsWithController
): void {
  if (
    args.editor &&
    !ReactEditor.isFocused(args.editor) &&
    !tool.withoutRefocus
  ) {
    // In Jest we don't actually have a React editor, so it will always appear
    // unfocused and refocusing it will cause an error. So skip this in tests.
    if (typeof jest === 'undefined') {
      ReactEditor.focus(args.editor);
    }
  }

  tool.action(args);

  args.controller?.actionReRenderToolbar();

  event.preventDefault();
  event.stopPropagation();
}

export default fireToolAction;
